// extracted by mini-css-extract-plugin
export default {"buttonPreview":"ButtonPreview_buttonPreview__WCIfM"};